import { j as o } from "./AccesRecoveryIcon-CUPieIxT.js";
const r = () => /* @__PURE__ */ o.jsxs("svg", { viewBox: "0 0 18 18", fill: "none", xmlns: "http://www.w3.org/2000/svg", children: [
  /* @__PURE__ */ o.jsx(
    "path",
    {
      d: "M16.334 1.86 14.934.6l-1.4 1.26-1.4-1.26-1.4 1.26L9.334.6l-1.4 1.26L6.534.6l-1.4 1.26L3.734.6v11.76h-2.8v2.52c0 1.394 1.25 2.52 2.8 2.52h11.2c1.549 0 2.8-1.126 2.8-2.52V.6zm-.467 13.02c0 .462-.42.84-.933.84S14 15.342 14 14.88v-2.52H5.6V3.12h10.267z",
      fill: "currentColor"
    }
  ),
  /* @__PURE__ */ o.jsx(
    "path",
    {
      d: "M12.445 4.333H6.223V6.2h6.222zm3.11 0H13.48V6.2h2.075zm-3.11 2.8H6.223v1.866h6.222zm3.11 0H13.48v1.866h2.075z",
      fill: "currentColor"
    }
  )
] });
export {
  r as T
};
